import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import scrollToElement from 'scroll-to-element';

export default class Story extends Component {

  constructor(props) {
    super(props);

    this.menuToggle = this.menuToggle.bind(this);

    this.state = {
      isOpen: true
    };
  }

  menuToggle() {
	this.setState({
  		isOpen: !this.state.isOpen
	});
  }



  render() {
    return (
		<Container_s fluid>
			<Container_1000 >
				<Dropdown_s toggle={this.menuToggle} dropdownOpen={this.state.isOpen}>
					<DropdownToggle caret>
						<p>LET US HELP!</p>
					</DropdownToggle>
				</Dropdown_s>
				<Collapse isOpen={this.state.isOpen}>
					<h4>Customer Care</h4>
					<p><Link to="/FAQ">FAQs</Link></p> 					
					<p><Link to="/ShippingHandling">Shipping & Handling</Link></p> 		
					{/*<p><Link to="/FindFragrance">Find a Fragrance</Link></p>*/}
					<p><Link to="/Contact">Contact Us</Link></p> 			
					<h4>Meet Us</h4>	
					<p><Link to="/aboutUs" onClick={this.props.aboutUsClick}>About The Owner</Link></p> 				
					<h4>Find Us</h4>		
					<p><Link to="/Locator">Candle Locations</Link></p>
				</Collapse>
			</Container_1000>
		</Container_s>
		);
	}
}

const Container_s = styled(Container)`
	padding: 20px 0 40px 0!important;
	text-align: center;
`;
const Dropdown_s = styled(({ dropdownOpen, ...rest }) => <Dropdown {...rest} />)`
	.dropdown-toggle {
		display: block;
		background: #BCA368!important;
		border: none;
		color: white!important;
		font-family: 'Handlee';
		font-weight: bold;
		padding: 0;
		width: 100%;
		cursor: pointer;

		p {
			display: block;
			margin: 0;
			text-align: left;
		}
		::after {
			float: right;
			margin-top: -12.8px;
		    border-top-width: ${a => a.dropdownOpen ? 0 : ""};
		    border-bottom: ${a => a.dropdownOpen ? "4.8px solid white" : ""};
		}

		:focus {
			box-shadow: none;
		}

	}
`;

const Container_1000 = styled(Container)`
	padding: 0 15px 0 15px!important;
	max-width: 1000px;

	.collapse, .collapsing {
		width: 100%!important;
		background-color: #BCA368;
		font-family: 'Raleway'!important;
		font-size: 12px;
		text-align: left;

		p {
			margin-bottom: 5px;
			margin-left: 10px;
			cursor: pointer;
			color: black;
			${media.md` font-size: 14px; `}
			${media.lg` font-size: 16px; `}

			:hover {
				text-decoration-line: underline;
			}

			a{
				color: black;
				cursor: pointer;
				${media.md` font-size: 14px; `}
				${media.lg` font-size: 16px; `}
			}
		}

		h4 {
			margin-top: 15px;
			display: inline-block;
			color: #76451F;
			font-weight: bold;
			font-size: 14px;
			${media.md` font-size: 16px; `}
			${media.lg` font-size: 18px; `}
		}
	}


`;



// WEBPACK FOOTER //
// ./src/components/FooterHelp.js